import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { environment } from './environments/environment';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';
import './app/formio-custom/date-range.component';
import './app/formio-custom/file.component';
import './app/formio-custom/Stopwatch.component';
import './app/formio-custom/GeoLocation.component';
import './app/formio-custom/geofencing.component';
import './app/formio-custom/Timer.component';
import './app/formio-custom/FaceRegister.component';
import './app/formio-custom/FaceDetection.component';
import './app/formio-custom/rich-text-editor.component';
import './app/formio-custom/tag-input/tag-input.formio';
import './app/formio-custom/barcode-reader/barcode-reader.formio';
import './app/formio-custom/barcode-reader/test-registration';
import { FormioModule } from '@formio/angular';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCe0xxWmFZfVtgcl9EZ1ZVTWYuP1ZhSXxWdkFgWX9YcnNRT2FcUU19XUs=')
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, FormioModule ),
    provideAnimations(),
    provideHttpClient(), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ]
}).catch((err) => console.error(err));
